import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

/**
 * Presentation-agnostic logic for the Signup Complete page.
 * Encapsulates navigation and clipboard copy behaviors.
 */
export function useSignupComplete(address: string) {
  const navigate = useNavigate()

  const onBack = useCallback(() => {
    navigate('/')
  }, [navigate])

  const onCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(address)
      toast.success('コピーしました')
    } catch {
      const ta = document.createElement('textarea')
      ta.value = address
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        toast.success('コピーしました')
      } finally {
        document.body.removeChild(ta)
      }
    }
  }, [address])

  return { onBack, onCopy }
}
